export default __webpack_public_path__ + "static/media/theamaya.f5da227c.png";